/* =====================================================================
Untamed Naturals -- Article Template Behaviour
---------------------------------------------------------------------
Progressively enhances the article template with:
1) a reading progress bar
2) an auto-generated table of contents (desktop rail + mobile accordion)
3) scrollspy highlighting for the active section
No dependencies, no jQuery. Runs once, only on the article template.
===================================================================== */
(function () {
"use strict";

if (!document.body.classList.contains("template-article")) {
return;
}

var articleBody = document.querySelector("[data-article-body]");
if (!articleBody) {
return;
}

/* -------------------------------------------------------------------
Reading progress bar
----------------------------------------------------------------- */
function initProgressBar() {
var bar = document.querySelector("[data-article-progress-bar]");
if (!bar) {
return;
}

function update() {
var rect = articleBody.getBoundingClientRect();
var docTop = rect.top + window.scrollY;
var total = rect.height - window.innerHeight * 0.5;
var scrolled = window.scrollY - docTop + window.innerHeight * 0.5;
var pct = total > 0 ? (scrolled / total) * 100 : 0;
pct = Math.min(100, Math.max(0, pct));
bar.style.width = pct + "%";
}

update();
window.addEventListener("scroll", update, { passive: true });
window.addEventListener("resize", update);
}

/* -------------------------------------------------------------------
Table of contents
----------------------------------------------------------------- */
function slugify(text, used) {
var base = text
.toLowerCase()
.trim()
.replace(/[^a-z0-9\s-]/g, "")
.replace(/\s+/g, "-")
.slice(0, 60);
if (!base) {
base = "section";
}
var slug = base;
var i = 1;
while (used[slug]) {
i += 1;
slug = base + "-" + i;
}
used[slug] = true;
return slug;
}

function initToc() {
var headings = articleBody.querySelectorAll("h2, h3");
if (headings.length < 2) {
return;
}

var desktopList = document.querySelector("[data-toc-list]");
var mobileList = document.querySelector("[data-toc-mobile-list]");
var desktopRail = document.querySelector("[data-toc-rail]");
var mobileWrap = document.querySelector("[data-toc-mobile]");
var used = {};
var entries = [];

headings.forEach(function (heading) {
if (!heading.id) {
heading.id = slugify(heading.textContent, used);
} else {
used[heading.id] = true;
}
heading.style.scrollMarginTop = "130px";
entries.push(heading);
});

entries.forEach(function (heading) {
var isSub = heading.tagName === "H3";
var link = document.createElement("a");
link.href = "#" + heading.id;
link.textContent = heading.textContent;

if (desktopList) {
var li = document.createElement("li");
if (isSub) {
li.className = "article-toc__list--sub";
}
var a = link.cloneNode(true);
a.dataset.tocTarget = heading.id;
li.appendChild(a);
desktopList.appendChild(li);
}

if (mobileList) {
var liM = document.createElement("li");
var aM = link.cloneNode(true);
liM.appendChild(aM);
mobileList.appendChild(liM);
}
});

if (desktopRail) {
desktopRail.hidden = false;
}
if (mobileWrap) {
mobileWrap.hidden = false;
}

initScrollspy(entries);
}

function initScrollspy(headings) {
var links = document.querySelectorAll("[data-toc-target]");
if (!links.length || !("IntersectionObserver" in window)) {
return;
}

var linkFor = {};
links.forEach(function (link) {
linkFor[link.dataset.tocTarget] = link;
});

var observer = new IntersectionObserver(
function (entries) {
entries.forEach(function (entry) {
var link = linkFor[entry.target.id];
if (!link) {
return;
}
if (entry.isIntersecting) {
links.forEach(function (l) {
l.classList.remove("is-active");
});
link.classList.add("is-active");
}
});
},
{ rootMargin: "-140px 0px -70% 0px", threshold: 0 }
);

headings.forEach(function (heading) {
observer.observe(heading);
});
}

/* -------------------------------------------------------------------
Init
----------------------------------------------------------------- */
initProgressBar();
initToc();
})();
